import {createSelector} from 'reselect';
const entity = 'Projects';

export const projects = createSelector([state => state[entity].projects], val => val);
export const categories = createSelector([state => state[entity].categories], val => val);
export const api = createSelector([state => state[entity].api], val => val);
export const isLoading = createSelector([state => state[entity].api.loading], val => val);
